
<template>
  <div class="develop">
    <img src="../../assets/img/deve/bg-1.png" alt />
  </div>
</template>

<script>
import { Tag, Col } from "vant";

export default {
  components: {
    [Tag.name]: Tag,
    [Col.name]: Col
  },

  data() {
    return {
      goods: {}
    };
  },

  methods: {}
};
</script>

<style lang="less" scoped> 
.develop {
  text-align: center;
  img {
    width: 80%;
    margin-top: 92px;
  }
}
</style>
